module.exports = __webpack_public_path__ + "media/images/lineup__iconClosePopup-3937ceb39601948b1ee8fc2f86fbab92.png";